import React, { useState } from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

const formFields = [
  { name: "societyName", label: "Society Name", type: "text", required: true },
  { name: "societyId", label: "Society ID", type: "text", required: true },
  { name: "contactPerson", label: "Contact Person", type: "text", required: true },
  { name: "contactEmail", label: "Contact Email", type: "email", required: true },
  { name: "contactNumber", label: "Contact Number", type: "tel", required: true },
];

const AddSocietyModal = ({ open, handleClose }) => {
  const [formData, setFormData] = useState(() => {
    // Dynamically create initial state from the formFields array
    const initialState = {};
    formFields.forEach((field) => {
      initialState[field.name] = "";
    });
    return initialState;
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    // Add your API call or other logic here
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          Add New Society
        </Typography>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {formFields.map((field) => (
            <TextField
              key={field.name}
              fullWidth
              label={field.label}
              name={field.name}
              type={field.type}
              value={formData[field.name]}
              onChange={handleChange}
              required={field.required}
            />
          ))}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            style={{
              backgroundColor: "#ED141F",
              "&:hover": {
                backgroundColor: "#ED141F",
              },
            }}
          >
            Register Society
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default AddSocietyModal;
